import React from 'react';
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';
import { FormContainer, FormContent } from './layoutComponents';

type Props<FormData extends FieldValues> = {
  formMethods: UseFormReturn<FormData>;
  children: React.ReactNode;
};

export const FormPageContainer = <FormData extends FieldValues>({ formMethods, children }: Props<FormData>) => {
  return (
    <FormProvider {...formMethods}>
      <FormContainer>
        <FormContent>{children}</FormContent>
      </FormContainer>
    </FormProvider>
  );
};
